"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _school = require("@/api/school/school");
var _player = require("@/api/player/player");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "阶段名称",
        prop: "stageName",
        isShow: true,
        width: "200"
      }, {
        name: "开始时间",
        prop: "beginTime",
        isShow: true,
        width: "200"
      }, {
        name: "结束时间",
        prop: "endTime",
        isShow: true,
        width: "200"
      }, {
        name: "得分",
        prop: "score",
        isShow: true,
        width: "100"
        // sortable: true,
      }],
      funBtns: [],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      options: [{
        name: "查看作品",
        class: "editor",
        option: "viewWorks",
        span: 5,
        field: {
          value: '-1',
          name: "workStatus",
          then: 'notEquals'
        }
      }, {
        name: "提交作品",
        class: "editor",
        option: "submitWorks",
        span: 5,
        isFuntion: true,
        optionFun: 'cszpPd'
      }],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      school: {
        bureauId: "",
        queryValue: "",
        type: 0
      },
      idList: [],
      checkBoxList: [],
      checkBoxs: []
    };
  },
  methods: {
    //判断是否可以提交作品
    cszpPd: function cszpPd(row, callback) {
      if ((row.workStatus == -1 || row.workStatus == 0 || row.workStatus == 2) && Date.parse(row.endTime) > new Date() && Date.parse(row.beginTime) < new Date()) {
        callback(true);
      } else {
        callback(false);
      }
    },
    // 获取选手阶段
    getPlayerStageList: function getPlayerStageList() {
      var _this = this;
      (0, _player.getPlayerStage)({
        groupId: this.$route.query.groupId,
        matchId: this.$route.query.matchId,
        pageSize: this.page.pageSize,
        pageNum: this.page.pageNumber
      }).then(function (res) {
        var data = res.data;
        console.log(data.list, "xuans ");
        data.list.forEach(function (item) {
          if (item.type === 1) {
            item.type = "中职";
          } else if (item.type === 2) {
            item.type = "高职";
          } else if (item.type === 3) {
            item.type = "本科";
          }
        });
        _this.totalData = data.total;
        _this.listData = data.list;
      });
    },
    // 查看作品
    viewWorks: function viewWorks(row) {
      this.$router.push({
        path: "/player/viewWorks",
        query: {
          worksId: row.workId
        }
      });
    },
    // 提交作品
    submitWorks: function submitWorks(row) {
      this.$router.push({
        path: "/player/uploadWorks",
        query: {
          id: row.workId,
          stageId: row.id,
          matchId: this.$route.query.matchId,
          groupId: this.$route.query.groupId
        }
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getPlayerStageList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getPlayerStageList();
    }
  },
  created: function created() {
    this.getPlayerStageList();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};